import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { ProductSheetComponent } from './product-sheet.component';
import { ProductReadyComponent } from './product-ready/product-ready.component';
import { ProductDetailsComponent } from './product-ready/product-details/product-details.component';
import { ProductGalleryModule } from '../product-gallery/product-gallery.module';
import { ProductContactsComponent } from './product-ready/product-details/product-contacts/product-contacts.component';
import { ProductDescriptionComponent } from './product-ready/product-details/product-description/product-description.component';
import { ProductFeaturesComponent } from './product-ready/product-details/product-features/product-features.component';
import { ProductSupportMaterialComponent } from './product-ready/product-details/product-support-material/product-support-material.component';
import { ProductNeighborhoodComponent } from './product-ready/product-details/product-neighborhood/product-neighborhood.component';
import { ProductModelsComponent } from './product-ready/product-details/product-models/product-models.component';
import { ProductSoldUnitsComponent } from './product-ready/product-details/product-sold-units/product-sold-units.component';
import { ProductSalesBlueprintComponent } from './product-ready/product-details/product-sales-blueprint/product-sales-blueprint.component';
import { ProductPricesComponent } from './product-ready/product-details/product-prices/product-prices.component';
import { ProductProposalsComponent } from './product-ready/product-details/product-proposals/product-proposals.component';
import { ProductLandscaperComponent } from './product-ready/product-details/product-landscaper/product-landscaper.component';
import { ProductArchitectComponent } from './product-ready/product-details/product-architect/product-architect.component';
import { NgxMaskModule } from 'ngx-mask';



@NgModule({
  declarations: [ProductSheetComponent, ProductReadyComponent, ProductDetailsComponent, ProductContactsComponent, ProductDescriptionComponent, ProductFeaturesComponent, ProductSupportMaterialComponent, ProductNeighborhoodComponent, ProductModelsComponent, ProductSoldUnitsComponent, ProductSalesBlueprintComponent, ProductPricesComponent, ProductProposalsComponent, ProductLandscaperComponent, ProductArchitectComponent],
  imports: [
    NgxMaskModule.forRoot({}),
    SharedModule,
    RouterModule,
    ProductGalleryModule
  ],
  exports: [ProductSheetComponent, ProductReadyComponent, ProductDetailsComponent],
  
})
export class ProductSheetModule { }
